import { useSession } from 'next-auth/react';
import { useQuery } from '@tanstack/react-query';
import {
  WalletInvestmentCategory,
  InvestorProfile,
} from '../../interface/walet';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getSuggestedWallet = async () => {
  const { data } = await api.get<WalletSuggestionResponse>(
    apiConfig.routes.wallet.suggested.investments
  );
  return data;
};

export const useGetSuggestedWallet = () => {
  const { data: session } = useSession();
  return useQuery({
    queryKey: ['wallet', 'suggested'],
    queryFn: getSuggestedWallet,
    enabled: !!session && !!session.access_token,
  });
};

type WalletSuggestionResponse = {
  categories: WalletInvestmentCategory[];
  investments_total: number;
  profile_title: InvestorProfile;
  strategies: WalletInvestmentCategory[];
  subcategories: WalletInvestmentCategory[];
};
